import TopicThree from "../../../components/market-contents/commodities-market-contents/TopicThree";

const CommoditiesMarketContentThree = () => {
  return (
    <>
      {/* <TopicThree /> */}

      <div className="how__work__market">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why The Pips</h1>
            <p>
              At The Pips, we combine market expertise, advanced technology, and
              transparent practices to help traders make informed and confident
              decisions. Whether you’re analyzing gold trends or tracking oil
              movements, our platform is designed to give you the precision,
              speed, and clarity you need to perform at your best in the
              commodities market.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Deep Liquidity and Tight Spreads</h4>
                </div>
                <p>
                  {/* Gain access to institutional-grade liquidity with consistently
                  competitive spreads, even during periods of high market
                  volatility. Our advanced infrastructure connects you to
                  top-tier liquidity providers, ensuring smoother order
                  execution and minimal slippage for optimal trading
                  performance. */}
                  Access deep liquidity, tight spreads, and smooth execution
                  with minimal slippage.
                </p>
              </div>
            </div>

            {/* Email Inquiries */}
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  {/* <h4>Advanced Analytical Tools and Real-Time Data</h4> */}
                  <h4>Advanced Analytical Tools</h4>
                </div>
                <p>
                  {/* Make informed decisions with access to advanced charting
                  tools, technical indicators, and real-time commodity data. The
                  Pips’ integration with MetaTrader 5 gives you precision
                  analytics, price alerts, and automated strategies to navigate
                  dynamic market conditions confidently. */}
                  Use advanced charts, real-time data, and automated tools for
                  smarter trading.
                </p>
              </div>
            </div>

            {/* Our Office */}
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  {/* <h4>Uncompromised Transparency and Security</h4> */}
                  <h4>Uncompromised Transparency</h4>
                </div>
                <p>
                  {/* At The Pips, integrity drives every aspect of our operations.
                  Trade knowing your funds and personal data are protected with
                  bank-grade encryption and strict compliance standards. Our
                  transparent pricing model ensures you always know exactly what
                  you’re paying for. No hidden costs, no surprises. */}
                  Use advanced charts, real-time data, and automated tools for
                  smarter trading.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommoditiesMarketContentThree;
